

































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BaseInput extends Vue {
  @Prop({ required: true }) readonly value!: string;
  @Prop({ default: "text" }) readonly type!: string;
  @Prop({ default: "" }) readonly label!: string;
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ required: true }) readonly name!: string;

  get preAddon() {
    return !!this.$slots.preaddon;
  }

  get postAddon() {
    return !!this.$slots.postaddon;
  }
}
